import godExmaple from "../assets/new-ui/godly/god-example.png";
import ConnectWallet from "../components/ConnectWallet";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import Bubble from "../components/coral/Bubble";
import CoralLeftType2 from "../components/coral/CoralLeftType2";
import CoralRightType2 from "../components/coral/CoralRightType2";

// import Aphrodite from '../assets/new-ui/godly/Aphrodite.gif'
// import Apollo from '../assets/new-ui/godly/Apollo.gif'
// import Ares from '../assets/new-ui/godly/Ares.gif'
// import Athena from '../assets/new-ui/godly/Athena.gif'
// import Hades from '../assets/new-ui/godly/Hades.gif'
// import Hephestus from '../assets/new-ui/godly/Hephestus.gif'
// import Hermes from '../assets/new-ui/godly/Hermes.gif'
// import Poseidon from '../assets/new-ui/godly/Poseidon.gif'
// import Zeus from '../assets/new-ui/godly/Zeus.gif'
import SharkGodly from "../components/SharkGodly";

import Aphrodite from "../assets/new-ui/godly/Aphrodite_Desktop.mp4";
import Apollo from "../assets/new-ui/godly/Apollo_Desktop.mp4";
import Ares from "../assets/new-ui/godly/Ares_Desktop.mp4";
import Athena from "../assets/new-ui/godly/Athena_Desktop.mp4";
import Hades from "../assets/new-ui/godly/Hades_Desktop.mp4";
import Hephestus from "../assets/new-ui/godly/Hephestus_Desktop.mp4";
import Hermes from "../assets/new-ui/godly/Hermes_Desktop.mp4";
import Poseidon from "../assets/new-ui/godly/Poseidon_Desktop.mp4";
import Zeus from "../assets/new-ui/godly/Zeus_Desktop.mp4";

export default function Godly() {
  return (
    <div className="godlyContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <CoralLeftType2 />
      <CoralRightType2 />
      <Bubble top={"200px"} />
      <div className="pageTitle">GODLY</div>
      {/* <div className='comingSoon'>Coming soon...</div> */}
      <div className="godList">
        <SharkGodly url={Aphrodite} />
        <SharkGodly url={Apollo} />
        <SharkGodly url={Ares} />
        <SharkGodly url={Athena} />
        <SharkGodly url={Hades} />
        <SharkGodly url={Hephestus} />
        <SharkGodly url={Hermes} />
        <SharkGodly url={Poseidon} />
        <SharkGodly url={Zeus} />

        {/* <img src={Aphrodite} alt='god shark' />
        <img src={Apollo} alt='god shark' />
        <img src={Ares} alt='god shark' />
        <img src={Athena} alt='god shark' />
        <img src={Hades} alt='god shark' />
        <img src={Hephestus} alt='god shark' />
        <img src={Hermes} alt='god shark' />
        <img src={Poseidon} alt='god shark' />
        <img src={Zeus} alt='god shark' /> */}
      </div>

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
